import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { S3_URL_PRODUCTS } from "../utils/constants";
import { addToWishlist } from "../services/authenticatedRequests";
import { AuthContext } from "../contexts/AuthContext";
import { toast } from "react-toastify";

const ProductCards = ({
  products,
  cardClass = "col-xl-2 col-lg-3 col-sm-4 col-6",
  title = null,
  showLoadmore = true,
  margin_top = "product mt-24",
}) => {
  const { isAuthenticated } = useContext(AuthContext);
  const [isWishlistSubmitting, setIsWishlistSubmitting] = useState(null);
  const handleAddToWishlist = async (productId) => {
    // if (isWishlistSubmitting) {
    //   return;
    // }
    setIsWishlistSubmitting(productId);
    try {
      await addToWishlist(productId);
      window.dispatchEvent(new Event("wishlistUpdated"));
      toast.success("Item added to wishlist");
    } catch (error) {
      console.error(error);
      const errorMessage =
        error?.response?.data || "An unexpected error occurred";
      toast.error(`Error adding to wishlist: ${errorMessage}`);
    } finally {
      setIsWishlistSubmitting(null);
    }
  };
  
  const gotToAllProducts = () => {
    window.location.href = "/products";
  };
  //console.log("cardClass",cardClass);
  return (
    <div className="container container-lg">
      <div className={margin_top}>
        {title && <h5>{title}</h5>}
        <div className="row gy-4 g-12">
          {products.length > 0 ? (
            products.map((product) => (
              <div className={cardClass} key={product.id}>
                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                  {product.configuration &&
                    product.configuration?.Sale?.configStatus === "active" && (
                      <span className="badge bg-main-600 text-white text-sm fw-semibold position-absolute top-0 start-0">
                        {product.configuration.Sale.collectionDisplayName}
                      </span>
                    )}
                  {product.configuration &&
                    product.configuration.Free_Delivery?.configStatus ===
                      "active" && (
                      <span className="badge bg-success-50 text-success-600 position-absolute bottom-0 end-0 ">
                        Free Delivery
                        <i className="ph ph-truck" />
                      </span>
                    )}

                  {isAuthenticated && (
                    <button
                      disabled={isWishlistSubmitting===product.id}
                      type="button"
                      onClick={() => handleAddToWishlist(product.id)}
                      className={`product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-11 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16 ${
                        isWishlistSubmitting === product.id
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                    >
                      {isWishlistSubmitting ===product.id ? (
                        <i className="ph ph-spinner animate-spin" /> // Loading icon
                      ) : (
                        <i className="ph ph-heart" />
                      )}
                    </button>
                  )}

                  <Link
                    to={`/product-details/${product.id}`}
                    className="product-card__thumb flex-center"
                  >
                    <img
                      src={`${S3_URL_PRODUCTS}${product.images?.[0]}`}
                      alt={product.name}
                    />
                  </Link>

                  {/* Badge positioned over the image */}

                  <div className="product-card__content mt-6">
                    <h6 className="title text-sm fw-semibold" style={{ height: "30px" }}>
                      <Link
                        to={`/product-details/${product.id}`}
                        className="link text-line-2"
                        title={product.name}
                      >
                        {product.name.length > 50
                          ? `${product.name.slice(0, 50)}...`
                          : product.name}
                      </Link>
                    </h6>

                    <div className="product-card__price">
                      {(() => {
                        // Get the config discount value if it exists.
                        const configDiscount =
                          product.configuration?.Sale?.collectionConfiguration
                            ?.discount;
                        const hasConfig =
                          product.configuration?.Sale?.configStatus ===
                            "active" && configDiscount != null;

                        if (hasConfig) {
                          const discount = Number(configDiscount);
                          if (product.salePrice) {
                            // Case 1: Config, sale price, and regular price available.
                            // Apply the discount on the sale price.
                            const computedSalePrice =
                              product.salePrice * (1 - discount / 100);
                            // Calculate the discount percentage using the regular price and the newly calculated sale price.
                            const discountPercentage = Math.round(
                              ((product.regularPrice - computedSalePrice) /
                                product.regularPrice) *
                                100
                            );
                            return (
                              <>
                                <div className="d-flex align-items-center gap-4">
                                  <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                                    LKR {product.regularPrice.toFixed(2)}
                                  </span>
                                  <span className="badge bg-main-600 text-white text-sm fw-semibold">
                                    -{discountPercentage}%
                                  </span>
                                </div>
                                <span className="text-heading text-sm fw-semibold">
                                  LKR {computedSalePrice.toFixed(2)}
                                </span>
                              </>
                            );
                          } else {
                            // Case 3: Config with only regular price available.
                            // Calculate the sale price using the regular price and config discount.
                            const computedSalePrice =
                              product.regularPrice * (1 - discount / 100);
                            return (
                              <>
                                <div className="d-flex align-items-center gap-4">
                                  <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                                    LKR {product.regularPrice.toFixed(2)}
                                  </span>
                                  <span className="badge bg-main-600 text-white text-sm fw-semibold">
                                    -{discount}%
                                  </span>
                                </div>
                                <span className="text-heading text-sm fw-semibold">
                                  LKR {computedSalePrice.toFixed(2)}
                                </span>
                              </>
                            );
                          }
                        } else {
                          // No configuration available.
                          if (product.salePrice) {
                            // Case 2: No config, but both sale price and regular price available.
                            const discountPercentage = Math.round(
                              ((product.regularPrice - product.salePrice) /
                                product.regularPrice) *
                                100
                            );
                            return (
                              <>
                                <div className="d-flex align-items-center gap-4">
                                  <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                                    LKR {product.regularPrice.toFixed(2)}
                                  </span>
                                  <span className="badge bg-main-600 text-white text-sm fw-semibold">
                                    -{discountPercentage}%
                                  </span>
                                </div>
                                <span className="text-heading text-sm fw-semibold">
                                  LKR {product.salePrice.toFixed(2)}
                                </span>
                              </>
                            );
                          } else {
                            // Case 4: Only regular price is available.
                            return (
                              <>
                                <div className="d-flex align-items-center gap-4">
                                  <span className="text-heading text-sm fw-semibold">
                                    LKR {product.regularPrice.toFixed(2)}
                                  </span>
                                  <span className="badge bg-main-600 text-white text-sm fw-semibold">
                                    {/* -{discountPercentage}% */}
                                  </span>
                                </div>
                                <span className="text-heading text-sm fw-semibold">
                                  {/* LKR{product.salePrice.toFixed(2)} */}
                                </span>
                              </>
                            );
                          }
                        }
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center w-100">No products found</p>
          )}
        </div>
        {showLoadmore && (
        <div className="mt-16 d-flex justify-content-center">
          <button
            onClick={gotToAllProducts}
            className="btn bg-main-600 text-white py-11 px-24 rounded-pill"
          >
            Load More Products
          </button>
        </div>
        )}
        {/* {showLoadmore && (
          <div className="mt-16 d-flex justify-content-center">
            {currentPage < totalPages - 1 ? (
              <button
                onClick={loadMoreProducts}
                className="btn bg-main-600 text-white py-11 px-24 rounded-pill"
              >
                Load More
                
              </button>
            ) : (
              <p className="text-center text-gray-500 mt-4">
                No more products to show.
              </p>
            )}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ProductCards;
